import React from "react";
import { Alert, AlertTitle, Box, Button } from "@mui/material";

import { selectVersionsByProjectId } from "fond/api";
import { setVersion } from "fond/project/redux";
import { Project } from "fond/types";
import { useAppDispatch, useAppSelector } from "fond/utils/hooks";

import { ScenarioPanelBomSection } from "./ScenarioPanelBomSection";

interface ScenarioPanelProps {
  // The project currently being viewed / edited
  project: Project;
}

const ScenarioPanel: React.FC<ScenarioPanelProps> = ({ project }: ScenarioPanelProps) => {
  const dispatch = useAppDispatch();
  const versions = useAppSelector((state) => selectVersionsByProjectId(state, project?.ID));
  const designVersion = versions ? versions.at(-1) : null;

  if (!project || !designVersion) return null;

  return (
    <Box data-testid="nbn-cost-to-serve-scenario-panel" m={2}>
      <Alert severity="info" sx={{ fontSize: "0.85rem" }}>
        <AlertTitle>View-only</AlertTitle>
        <Box mt={1}>This scenario has been completed and is now view-only. Return to the original version to create and run new scenarios.</Box>
        <Button variant="outlined" sx={{ mt: 2, mb: 1, fontSize: "0.85rem" }} onClick={() => dispatch(setVersion(designVersion.ID))}>
          Go to original version
        </Button>
      </Alert>
      <ScenarioPanelBomSection project={project} />
    </Box>
  );
};

export default ScenarioPanel;
